<script setup lang="ts">
import FileViewer from '@/components/common/file-viewer.vue';
import type { models } from 'cesg-shared';
import { type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

defineProps({
  file: {
    type: Object as PropType<models.SupplierInvoiceFile>,
    required: true,
  },
  changeFile: {
    type: Boolean,
    default: true,
  },
});

const { t } = useI18n();

const emit = defineEmits(['remove']);
</script>

<template>
  <div class="render-wrapper">
    <div class="top-bar">
      <span class="filename">{{ file.name }}</span>

      <button v-if="changeFile" @click="emit('remove')" class="close-btn">
        {{ t('RenderInvoice.changeFile') }}
      </button>
    </div>

    <div class="viewer-container">
      <FileViewer :files="[file]" :allow-multiple="false" />
    </div>
  </div>
</template>

<style scoped>
.render-wrapper {
  display: flex;
  flex-direction: column;
  height: fit-content;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: white;
}

.top-bar {
  padding: 0.5rem 1rem;
  background: #f1f5f9;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 40px;
}

.filename {
  font-weight: 600;
  font-size: 0.9rem;
  color: #334155;
}

.close-btn {
  background: none;
  border: none;
  color: #ef4444;
  font-size: 0.85rem;
  cursor: pointer;
  font-weight: 600;
}
.close-btn:hover {
  text-decoration: underline;
}

.viewer-container {
  flex: 1;
  overflow: hidden;
}
</style>
